import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useGroupManager } from "../../hooks/useGroupManager";

export function DesktopArrows() {
  const { selectedGroup, handleAdd, handleRemove } = useGroupManager();

  return (
    <div className="flex flex-col gap-3">
      <button
        disabled={!selectedGroup}
        className={`border border-black  px-4 py-1 rounded lg:text-base sm:text-sm ${
          selectedGroup
            ? "bg-secondary-blue hover:bg-tertiary-blue text-white"
            : "bg-gray-400"
        } focus-visible:outline-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2`}
        onClick={() => handleAdd()}
      >
        {"Ajouter au groupe "}
        <FaArrowRight className="inline" />
      </button>
      <button
        className={`border border-black px-4 py-1 rounded  lg:text-base sm:text-sm ${
          selectedGroup
            ? "bg-secondary-yellow hover:bg-tertiary-yellow text-white"
            : "bg-gray-400"
        } focus-visible:outline-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2`}
        onClick={() => handleRemove()}
      >
        <FaArrowLeft className="inline" /> {" Retirer du groupe"}
      </button>
    </div>
  );
}
